module.exports = __webpack_public_path__ + "assets/img/D2.1c3a2199.jpg";